import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from "react";
import cx from "classnames";
import { IconDelete, IconEditCustom } from "@sfx/icons";
import moment from "moment";
import styles from "./cell.module.css.json";
export var defaultContent = "--";
export var TwoRowCell = function TwoRowCell(_ref) {
  var topContent = _ref.topContent,
      bottomContent = _ref.bottomContent,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      className = _ref.className;
  return /*#__PURE__*/React.createElement("section", {
    className: cx(className, styles["twoRowCell"], styles["ellipsisText"]),
    style: _objectSpread({
      display: "flex",
      flexDirection: "column"
    }, style)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles["ellipsisText"]
  }, topContent), /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles["ellipsisText"], " ").concat(styles["smallFont"])
  }, bottomContent));
};
export var CellSubscriptionUser = function CellSubscriptionUser(_ref2) {
  var licensedUser = _ref2.licensedUser;
  var FirstName = licensedUser.FirstName,
      LastName = licensedUser.LastName,
      Email = licensedUser.Email,
      AvatarUrl = licensedUser.AvatarUrl;
  var topContent = "".concat(FirstName, " ").concat(LastName);
  var avatarDom;

  if (AvatarUrl) {
    avatarDom = /*#__PURE__*/React.createElement("img", {
      className: styles["tableAvatar"],
      src: AvatarUrl,
      alt: "avatar"
    });
  } else {
    var avatarFirstName = FirstName && FirstName.substring(0, 1) && FirstName.substring(0, 1).toUpperCase() || "";
    var avatarLastName = LastName && LastName.substring(0, 1) && LastName.substring(0, 1).toUpperCase() || "";
    var name = "".concat(avatarFirstName).concat(avatarLastName);
    avatarDom = /*#__PURE__*/React.createElement("div", {
      className: styles["tableAvatar"]
    }, name);
  }

  return /*#__PURE__*/React.createElement("div", {
    className: styles["nameCell"]
  }, avatarDom, /*#__PURE__*/React.createElement(TwoRowCell, {
    topContent: topContent,
    bottomContent: Email ? Email : defaultContent
  }));
};
export var CellName = function CellName(_ref3) {
  var row = _ref3.row;
  var _row$original = row.original,
      FirstName = _row$original.FirstName,
      LastName = _row$original.LastName,
      Email = _row$original.Email,
      AvatarUrl = _row$original.AvatarUrl;
  var topContent = "".concat(FirstName, " ").concat(LastName);
  var avatarDom;

  if (AvatarUrl) {
    avatarDom = /*#__PURE__*/React.createElement("img", {
      className: styles["tableAvatar"],
      src: AvatarUrl,
      alt: "avatar"
    });
  } else {
    var avatarFirstName = FirstName && FirstName.substring(0, 1) && FirstName.substring(0, 1).toUpperCase() || "";
    var avatarLastName = LastName && LastName.substring(0, 1) && LastName.substring(0, 1).toUpperCase() || "";
    var name = "".concat(avatarFirstName).concat(avatarLastName);
    avatarDom = /*#__PURE__*/React.createElement("div", {
      className: styles["tableAvatar"]
    }, name);
  }

  return /*#__PURE__*/React.createElement("div", {
    className: styles["nameCell"]
  }, avatarDom, /*#__PURE__*/React.createElement(TwoRowCell, {
    topContent: topContent,
    bottomContent: Email ? Email : defaultContent
  }));
};
export var CellAccess = function CellAccess(_ref4) {
  var row = _ref4.row;
  var _row$original2 = row.original,
      LastAccessSolution = _row$original2.LastAccessSolution,
      LastAccessTime = _row$original2.LastAccessTime;
  var formatLastAccess = LastAccessTime ? moment.utc(LastAccessTime).local().format("YYYY-MM-DD h:mm:ss A") : "never";
  return /*#__PURE__*/React.createElement(TwoRowCell, {
    topContent: LastAccessSolution ? LastAccessSolution : defaultContent,
    bottomContent: formatLastAccess
  });
};
export var CellAccessTime = function CellAccessTime(_ref5) {
  var row = _ref5.row;
  var LastAccessTime = row.original.LastAccessTime;
  var formatLastAccess = LastAccessTime ? moment.utc(LastAccessTime).local().format("YYYY-MM-DD h:mm:ss A") : "never";
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles.ellipsisText, "  ").concat(styles.lineHeight40)
  }, formatLastAccess);
};
export var CellSfxRole = function CellSfxRole(_ref6) {
  var row = _ref6.row;
  var sfxRole = row.original.sfxRole;
  var displayRoles = Array.isArray(sfxRole) && sfxRole.length > 0 ? sfxRole.map(function (item) {
    return item.name;
  }).join(", ") : defaultContent;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles.ellipsisText, "  ").concat(styles.lineHeight40)
  }, displayRoles);
};
export var CellRoles = function CellRoles(_ref7) {
  var row = _ref7.row;
  var Roles = row.original.Roles;
  var displayRoles = Array.isArray(Roles) && Roles.length > 0 ? Roles.map(function (item) {
    return item.displayName;
  }).join(", ") : defaultContent;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles.ellipsisText, "  ").concat(styles.lineHeight40)
  }, displayRoles);
};
export var SolutionCellActions = function SolutionCellActions(_ref8) {
  var handleEdit = _ref8.handleEdit;
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles.solutionCellActions, "cellActions")
  }, /*#__PURE__*/React.createElement("span", {
    onClick: function onClick() {
      return handleEdit();
    }
  }, /*#__PURE__*/React.createElement(IconEditCustom, {
    size: 18,
    style: {
      marginRight: "17px",
      cursor: "pointer"
    }
  })));
};
export var CellUserModalName = function CellUserModalName(_ref9) {
  var row = _ref9.row,
      activeClass = _ref9.activeClass;
  var _row$original3 = row.original,
      LastName = _row$original3.LastName,
      FirstName = _row$original3.FirstName,
      userName = _row$original3.userName;
  return /*#__PURE__*/React.createElement("span", {
    className: activeClass
  }, /*#__PURE__*/React.createElement(TwoRowCell, {
    topContent: "".concat(FirstName, " ").concat(LastName),
    bottomContent: userName
  }));
};
export var CellUserModalSolution = function CellUserModalSolution(_ref10) {
  var row = _ref10.row;
  var solution = row.original.solution;
  var displaySolutions = Array.isArray(solution) && solution.length > 0 ? solution.map(function (item) {
    return {
      id: item._id,
      topContent: item.name,
      bottomContent: item.roles && item.roles.map(function (n) {
        return n.name || n.displayName;
      }).join(",")
    };
  }) : defaultContent;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles.ellipsisText, "  ").concat(styles.lineHeight40)
  }, displaySolutions === defaultContent ? defaultContent : displaySolutions.map(function (i) {
    return /*#__PURE__*/React.createElement(TwoRowCell, {
      key: i.id,
      topContent: i.topContent,
      bottomContent: i.bottomContent
    });
  }));
};
export var CellUserModalRoles = function CellUserModalRoles(_ref11) {
  var row = _ref11.row;
  var sfxRole = row.original.sfxRole;
  var displayRoles = Array.isArray(sfxRole) && sfxRole.length > 0 ? sfxRole.map(function (item) {
    return item.displayName || item.name;
  }).join(", ") : defaultContent;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles["userModalRoles"])
  }, displayRoles);
};
export var CellUserModalActions = function CellUserModalActions(_ref12) {
  var row = _ref12.row,
      formUser = _ref12.formUser,
      editFormUser = _ref12.editFormUser,
      deleteFormUser = _ref12.deleteFormUser;
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles["userModalAction"], "cellActions")
  }, /*#__PURE__*/React.createElement("span", {
    onClick: function onClick(e) {
      return editFormUser(e, row.original);
    }
  }, /*#__PURE__*/React.createElement(IconEditCustom, {
    size: "18",
    className: styles["userModalIconWrap"]
  })), formUser && formUser._id !== row.original._id && /*#__PURE__*/React.createElement("span", {
    onClick: function onClick(e) {
      return deleteFormUser(e, row.original);
    }
  }, /*#__PURE__*/React.createElement(IconDelete, {
    size: "18",
    className: styles["userModalIconWrap"]
  })));
};